import NumberOfVariantsForDigit from '../../components/calculation-form/components/form-items/number-of-varints-for-digit'
import { DataSourceItem } from '../../helpers/convert-calculations-to-data-source'
import isCalculation from '../../helpers/is-calculation'
import { CalculationColumn } from '../../types/column-types'
import { validateNumberOfVariantsForDigitColumn } from '../../helpers/validators'
import { isDurstMachine } from '../../../../helpers/is-durst-machine'

export const numberOfVariantsForDigitColumn: CalculationColumn = {
    dataIndex: 'numberOfVariantsForDigit',
    title: 'Кол-во видов Durst',
    width: 52,
    editable: true,
    FormItem: <NumberOfVariantsForDigit />,
    validator: validateNumberOfVariantsForDigitColumn,
    onCell: (record: DataSourceItem) => {
        if (isCalculation(record)) {
            return { colSpan: 0 }
        }
        return {
            colSpan: 1,
            editable: isDurstMachine(record.machine),
        }
    },
}
